import _extends from 'babel-runtime/helpers/extends';

import _ from 'lodash';
import { mapState } from 'vuex';
import { previewMixin } from '../mixin/preview.js';
import PsLanguageSelect from '@/components/IconLanguage/PsLanguageSelect.vue';

export default {
  mixins: [previewMixin],
  components: {
    PsLanguageSelect: PsLanguageSelect
  },

  data: function data() {
    return {
      fallbackLocale: ''
    };
  },


  computed: _extends({}, mapState({
    currentLanguage: function currentLanguage(state) {
      return state.creative.template.currentLanguage;
    },
    zipLangList: function zipLangList(state) {
      return state.creative.template.zipLangList;
    }
  }), {
    i18n: function i18n() {
      if (this.templateConfig && this.templateConfig.json_config) {
        return this.templateConfig.json_config.i18n;
      }
      return null;
    },


    // 是否是代码字
    isI18n: function isI18n() {
      if (this.i18n && this.i18n.fallbackLocale && this.i18n.languages) {
        return true;
      }
      return false;
    },


    // 是否是图片字
    isZipLang: function isZipLang() {
      if (this.zipLangList && this.zipLangList.length) {
        return true;
      }
      return false;
    },
    visible: function visible() {
      // 图片字和代码字都有语言选择
      if (this.isI18n || this.isZipLang) {
        return true;
      }

      return false;
    },
    languageOptions: function languageOptions() {
      if (this.isI18n) {
        var cloneLanguages = _.cloneDeep(this.i18n.languages);
        return [{
          label: this.$t('playTurbo.custom.previewer.selectLanguage'),
          options: _.map(cloneLanguages, function (code, key) {
            return {
              value: key,
              label: key
            };
          })
        }];
      } else if (this.isZipLang) {
        return [{
          label: this.$t('playTurbo.custom.previewer.selectLanguage'),
          options: this.zipLangList.map(function (item) {
            return {
              value: item.zip_sign,
              label: item.zip_sign.toUpperCase()
            };
          })
        }];
      }
      return [];
    }
  }),

  watch: {
    visible: function visible(val) {
      if (val) {
        this.fallbackLocale = this.currentLanguage;
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    /**
     * iframe里面游戏语言没有跟外部指定的选择语言同步
     * 通过监听游戏是否加载成功来主动触发一次语言的更新
     */
    var unWatch = this.$watch(function () {
      return _this.canLivePreviewAndGameReady;
    }, function (flag) {
      if (flag) {
        _this.changeLanguage(_this.currentLanguage);
        unWatch();
      }
    });
  },


  methods: {
    changeLanguage: function changeLanguage(val) {
      var _this2 = this;

      this.$nextTick(function () {
        _this2.$store.commit('creative/template/updatePreviewLanguage', val);
        _this2.preview();
      });
    }
  }
};